import { useContext, useState } from 'react'
import ResizableModal from '../../../../../../ui/ResizableModal'
import CustomButton from '../../../../../../ui/CustomButton'
import { Title } from '../../../../../../ui'
import { OrganizationAPI } from '../../../../../../../../api/organization.api'
import GlobalContext from '../../../../../../../../context/global-context'
import ListDesconciliar from './ListDesconciliar'

const DesconciliarCaja = ({ open, setOpen, rows, tipoMovimiento,setSwitchGetData}) => {
  const organizationAPI = new OrganizationAPI()
  const { currentBusiness } = useContext(GlobalContext)
  const [montoTotalSeleccionado, setMontoTotalSeleccionado] = useState(0)
  const [filasSeleccionadas, setFilasSeleccionadas] = useState([])
  const [rowsSeleccionables, setRowsSeleccionables] = useState([])
  const handleClose = () => setOpen(false)

const handleSeleccionar = (row, allRows = []) => {

  const campoMonto = tipoMovimiento === 'cargo' ? 'montoCargo' : 'montoAbono'
  if (row === 'SELECCIONAR_TODOS') {

    const nuevasIds = allRows.map(r => r.idPrincipal)
    const total = allRows.reduce((sum, r) => sum + (r[campoMonto] || 0), 0)

    setFilasSeleccionadas(nuevasIds)
    setMontoTotalSeleccionado(total)
    return
  }

  if (row === 'DESELECCIONAR_TODOS') {
    setFilasSeleccionadas([])
    setMontoTotalSeleccionado(0)
    return
  }

  const yaSeleccionado = filasSeleccionadas.includes(row.idPrincipal)
  const monto = row[campoMonto] || 0

  if (yaSeleccionado) {
    setFilasSeleccionadas(filasSeleccionadas.filter(id => id !== row.idPrincipal))
    setMontoTotalSeleccionado(prev => prev - monto)
  } else {
    setFilasSeleccionadas([...filasSeleccionadas, row.idPrincipal])
    setMontoTotalSeleccionado(prev => prev + monto)
  }
}

  const handleCaja = async () => {
    try {
      const ids = rowsSeleccionables
        .flatMap(r => r.auxiliar)
        .filter(aux => filasSeleccionadas.includes(aux.idPrincipal))
        .map(aux => aux.idPrincipal)

      const body = { ids }
      await organizationAPI.postCajaMultipleDes({ businessId: currentBusiness.id }, body)
      setSwitchGetData(true)
      handleClose()
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <ResizableModal
      open={open}
      onClose={handleClose}
      footer={
        <>
          <CustomButton
            title='CANCELAR'
            color='primary'
            className='rounded-full'
            onClick={handleClose}
          />
          <CustomButton
            title='GRABAR DESCONCILIACIÓN'
            color='accent2'
            className='rounded-full'
            onClick={handleCaja}
          />
        </>
      }
    >
      <div className='mt-4'>
        <div className='flex justify-between items-center mb-6'>
          <div>
            <Title className='text-3xl'>{tipoMovimiento === 'cargo' ? 'Pago Masivo de Documentos' : 'Cobro Masivo de Documentos'}</Title>
          </div>
        </div>
        <div className="p-4 mt-2 bg-white rounded-3xl shadow-md flex flex-col overflow-hidden" style={{ height: 'calc(100vh - 12rem)' }}>
       { /*<InputField label="Monto Total" type="text" value={montoTotalSeleccionado.toLocaleString('es-CL')} readOnly/>*/}
        <div className='mt-6 px-6 overflow-auto'>
          <ListDesconciliar
            rows={rows}
            onSeleccionar={handleSeleccionar}
            filasSeleccionadas={filasSeleccionadas}
            setRowsSeleccionables={setRowsSeleccionables}
            tipoMovimiento={tipoMovimiento}
            setFilasSeleccionadas={setFilasSeleccionadas}
            setMontoTotalSeleccionado={setMontoTotalSeleccionado}
            montoTotalSeleccionado={montoTotalSeleccionado}
          />
        </div>
        </div>
      </div>
    </ResizableModal>
  )
}

export default DesconciliarCaja